import { Box, Center, Flex, Icon } from '@chakra-ui/react'
import { Grid01Icon, ListIcon } from '../../assets/icons'

const ListGridSwitcher = ({ isGrid, onToggle }: { isGrid: boolean; onToggle: () => void }) => {
  return (
    <Flex
      w="76px"
      h="32px"
      p="3px"
      borderRadius="8px"
      borderColor="solid.100"
      borderWidth="1px"
      pos="relative"
      justifyContent="space-between"
      alignItems="center"
      transition="0.2s ease-out"
      _focus={{
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      }}
      _hover={{
        boxShadow: '0px 0px 0px 3px #282E3A0F, 0px 1px 2px 0px #A4ACB966',
        border: 'solid.100',
        outline: 'solid.100',
      }}
    >
      <Box
        transition="0.2s ease-out"
        pos="absolute"
        w="32px"
        h="24px"
        bg="solid.50"
        borderRadius="5.5px"
        left={isGrid ? '3px' : '39px'}
        top="3px"
      />
      <Center w="32px" pos="absolute" left="3px" cursor="pointer" onClick={() => (!isGrid ? onToggle() : {})}>
        <Icon w="16px" h="16px" viewBox="0 0 24 24" fill="none" color="solid.500">
          <Grid01Icon />
        </Icon>
      </Center>
      <Center w="32px" pos="absolute" right="3px" cursor="pointer" onClick={() => (isGrid ? onToggle() : {})}>
        <Icon w="16px" h="16px" viewBox="0 0 24 24" fill="none" color="solid.500">
          <ListIcon />
        </Icon>
      </Center>
    </Flex>
  )
}

export default ListGridSwitcher
